import store from '@/store'

export const TOKEN_HEADER = 'access-token'
export function getToken() {
  return store.getters['user/token']
}

export function removeToken() {
  return store.commit('user/removeToken')
}
